import { css } from "@vitality-ds/system";
import { layoutVariants } from "../../helpers/styles";
export default css({
  display: "block",
  boxSizing: "border-box",
  variants: layoutVariants
});